export var PRIMARY_LABEL_TEST_ID = 'primary-label';
export var DELIVERY_LABEL_TEST_ID = 'delivery-label';
export var PRICE = 'price';
export var PREVIOUS_PRICE = 'previous-price';
export var DELIVERY_EVENT_LABEL_TEST_ID = 'delivery-event-label';